import { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import SortedHeader from "../../../components/Tables/SortedHeader";
import { useTranslation } from "react-i18next";
import "./Candidate.scss";
import moment from "moment/moment";

export default function ResultTable({
  searchCandidateResult,
  setSearch,
  search
}) {
  const history = useHistory();
  const { t } = useTranslation();
  const [headers, setHeaders] = useState([
    { label: t("Company"), field: "company" },
    { label: t("Type"), field: "type" },
    { label: t("Full Name"), field: "fullName" },
    { label: t("Phone") },
    { label: t("LinkedIn") },
    { label: t("Professional Category"), field: "profesionalCategory" },
    { label: t("Modified Date"), field: "modifiedDate" },
    { label: t("Role"), field: "role" },
    { label: t("Availability"), field: "availability" }
  ]);

  function goToDetails(candidate) {
    history.push(
      `/global/${candidate.type}/${candidate.id}/${search.nameOrEmail}`
    );
  }

  function openLinkedinCandidate(event) {
    event.stopPropagation();
  }

  return (
    <>
      <div style={{marginTop: "40px"}}>
        <div className="table-wrap">
          <table style={{ marginTop: "40px" }}>
            <thead>
              <SortedHeader
                searchObject={search}
                setSearchObject={setSearch}
                headers={headers}
                setHeaders={setHeaders}
              />
            </thead>
            <tbody>
              {searchCandidateResult.map((candidate) => (
                <tr
                  key={candidate.id}
                  onClick={() => goToDetails(candidate)}
                  style={{ height: "50px" }}
                >
                  <td>{candidate.company}</td>
                  <td>{candidate.type}</td>
                  <td>{candidate.fullName}</td>
                  <td>{candidate.phoneNumber}</td>
                  {candidate.linkedIn ? (
                    <td title={candidate.linkedIn}>
                      <a
                        href={candidate.linkedIn}
                        target="_blank"
                        onClick={openLinkedinCandidate}
                      >
                        <i class="bi bi-linkedin linkedin-active-size"></i>
                      </a>
                    </td>
                  ) : (
                    <td>
                      <i class="bi bi-linkedin linkedin-inactive-size"></i>
                    </td>
                  )}
                  <td>{candidate.profesionalCategory}</td>
                  <td>{moment(candidate.modifiedDate).format("DD-MM-YYYY")}</td>
                  <td>{candidate.role}</td>
                  <td>{candidate.availability}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {searchCandidateResult.length === 0 && (
            <div className="loader-wrapper">{t("No results found.")}</div>
          )}
        </div>
      </div>
    </>
  );
}